<template>
  <!-- 联系我们 - 在线留言 -->
  <div class="contact_container">
    <div class="contact_wrap">
      <div class="from_wrap">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-row ><el-col :span="24">
            <div class="title_wrap">
              <div class="title">在线留言</div>
              <div class="subTitle">请留下您的联系方式，我们会及时联系您！</div>
            </div>
          </el-col></el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item prop="name">
                <el-input v-model="ruleForm.name" placeholder="姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="phone">
                <el-input v-model="ruleForm.phone" placeholder="手机*"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="email">
                <el-input v-model.number="ruleForm.email" placeholder="邮箱"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div>
            <el-form-item >
              <el-input
                type="textarea"
                v-model="ruleForm.desc"
                :rows="3"
                placeholder="留言内容*"
              ></el-input>
            </el-form-item>
          </div>
          <div class="btn_box">
            <el-form-item>
              <el-button type="primary" style="width: 12%;" @click="submitForm('ruleForm')">提交</el-button>
              <el-button style="width: 12%" @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      const validatePhone = (rule, value, callback) =>{
        if (!value) callback(new Error('请输入手机号码'));
        if (!/^1[3-9]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'));
        }else {
          callback();
        }
      };
      const validateEmail = (rule, value, callback) => {
        if (value === "") {
          callback()
        }else {
          const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailPattern.test(value)) {
            callback(new Error("邮箱格式不正确"));
          } else {
            callback();
          }
        }
      };

      return {
        ruleForm: {
          name: '',
          phone: '',
          email: '',
          desc: ''
        },
        rules: {
          phone: [
            { required: true, validator: validatePhone, trigger: 'blur' }
          ],
          email: [
            { validator: validateEmail, trigger: 'blur' }
          ],
          desc: [
            { required: true, message: '请输入留言内容', trigger: 'blur' }
          ]
        }
      }
    },

    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>

<style scoped lang="scss">
.contact_container {
  width: 100%;
  height: 100%;
  min-height: 300px;
  padding: 50px 10px;
  .contact_wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1360px;
    margin: 0 auto;
    padding: 30px 50px;
    .from_wrap {
      width: 100%;
    }
    .title_wrap {
      width: 100%;
      height: auto;
      text-align: center;
      color: rgba(51, 51, 51, 1);
      .title {
        line-height: normal;
        font-size: 30px;
        font-weight: bold;
      }
      .subTitle {
        margin-top: 10px;
        margin-bottom: 20px;
        line-height: normal;
        font-size: 18px;
      }
    }
    .btn_box {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
